export const insuranceCompanies = [
    {
        value: "Aetna",
        label: "Aetna"
    }, {
        value: "Kaiser Permanente",
        label: "Kaiser Permanente"
    }, {
        value: "Elevance Health (Anthem)",
        label: "Elevance Health (Anthem)"
    }, {
        value: "UnitedHealth",
        label: "UnitedHealth"
    }, {
        value: "Guidewell (Florida Blue)",
        label: "GuideWell (Florida Blue)"
    }, {
        value: "Blue Cross Blue Shield",
        label: "Blue Cross Blue Shield"
    }, {
        value: "Humana",
        label: "Humana"
    }]
export const genders = [{
    value: "Male",
    label: "Male"
}, {
    value: "Female",
    label: "Female"
}, {
    value: "Non binary",
    label: "Non-Binary"
}, {
    value: "Other",
    label: "Other"
}]

// NOTE WE EVENTUALLY WANT SUPER ADMIN BUT FOR NOW LETS KEEP IT LOCKED BEHIND CLOSED DOORS
export const role_types = [
    {
        value: "Admin",
        label: "Admin"
    },
    {
        value: "Standard",
        label: "Standard"
    }
]
